export async function callApi(promise) {
    try {
        const response = await promise;
        if (response.status === 200 || response.status === 201) {
            return {
                data: response.body,
                error: null,
                status: response.status,
            };
        }
        const { body } = response;
        if (body !== null && typeof body === 'object' && 'error' in body) {
            return {
                data: null,
                error: body.error,
                status: response.status,
            };
        }
        return {
            data: null,
            error: `Request failed with status ${response.status}`,
            status: response.status,
        };
    }
    catch (e) {
        return {
            data: null,
            error: e instanceof Error ? e.message : 'Network error',
            status: null,
        };
    }
}
